import { render, staticRenderFns } from "./EntranceGuardLogPage.vue?vue&type=template&id=772acc72&scoped=true&"
import script from "./EntranceGuardLogPage.vue?vue&type=script&lang=js&"
export * from "./EntranceGuardLogPage.vue?vue&type=script&lang=js&"
import style0 from "./EntranceGuardLogPage.vue?vue&type=style&index=0&id=772acc72&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772acc72",
  null
  
)

export default component.exports